import React from 'react';

import { Container } from './styles';

interface LoadingProps {
  show: boolean;
}

const Loading: React.FC<LoadingProps> = ({ show }) => {
  return (
    <>
      {show && (
        <Container className="container-fluid loader-wrap">
          <div className="row h-100">
            <div className="col-10 col-md-6 col-lg-5 col-xl-3 mx-auto text-center align-self-center">
              <div className="loader-cube-wrap mx-auto">
                <div className="loader-cube1 loader-cube" />
                <div className="loader-cube2 loader-cube" />
                <div className="loader-cube4 loader-cube" />
                <div className="loader-cube3 loader-cube" />
              </div>
              <p>
                <strong>Carregando</strong>
              </p>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

export default Loading;
